<ion-header
  class="product-options_header ion-no-border"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-header-modal-tablet'
      : 'ion-header-modal-mobile'
  "
>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="back-product-options-modal-button"
        text=""
        (click)="goBack()"
      ></ion-back-button>
    </ion-buttons>
    <ion-label data-cy="select-product-label">{{
      'i18n.requestCredit.selectProduct' | translate
    }}</ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  *ngIf="serviceRequestService?.products$ | async as products"
  class="product-options_content"
  [ngClass]="
    platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'ion-content-modal-tablet'
      : 'ion-content-modal-mobile'
  "
>
  <div class="searchbar-section" slot="fixed">
    <ion-searchbar
      id="products-searchbar"
      data-cy="products-searchbar-input"
      class="search"
      mode="md"
      placeholder="{{
        'i18n.requestCredit.searchProductsFromOrder' | translate
      }}"
      (ionInput)="filterProductNumbers()"
      [debounce]="serviceRequestService?.debounceTime"
      [(ngModel)]="serviceRequestService.searchKey"
    >
    </ion-searchbar>
  </div>
  <div
    *ngIf="!products?.length && serviceRequestService?.searchKey"
    class="no-data-found"
  >
    <p data-cy="no-product-numbers-found-text">
      {{ 'i18n.requestCredit.noProductNumbersFound' | translate }}
    </p>
  </div>
  <ion-list *ngIf="products?.length" class="products-list">
    <ion-item-divider></ion-item-divider>
    <ion-radio-group
      class="radio-options"
      value="{{ serviceRequestService?.modalRelatedParams?.productNumber }}"
    >
      <ion-item
        *ngFor="let product of products"
        (click)="onSelectProduct(product)"
        [attr.data-cy]="'select' + product?.productNumber"
      >
        <ion-thumbnail *ngIf="product?.productImage" slot="start">
          <img src="{{ product?.productImage }}" />
        </ion-thumbnail>
        <ion-icon
          *ngIf="!product?.productImage"
          name="restaurant"
          slot="start"
        ></ion-icon>
        <div class="radio-option-text">
          <ion-label
            [attr.data-cy]="
              'product-number-' + product?.productNumber + '-text'
            "
          >
            #{{ product?.productNumber }}
            &nbsp;|&nbsp;
            {{ product?.productPackSize }}
          </ion-label>
          <ion-label
            id="product-description"
            [attr.data-cy]="
              'product-description-' + product?.productNumber + '-text'
            "
          >
            {{ product?.productDescription | titlecase }}
          </ion-label>
        </div>
        <ion-radio
          aria-labelledby="product-description"
          mode="md"
          slot="end"
          value="{{ product?.productNumber }}"
          [attr.data-cy]="'product-number-' + product?.productNumber + '-radio'"
        ></ion-radio>
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="select-modal-btn"
        data-cy="select-product-options-modal"
        [ngClass]="
          platformService?.platformType ===
          platformService?.platformEnum?.tablet
            ? !serviceRequestService?.modalRelatedParams?.product
              ? 'usf-fill-disabled-dsktp-tblt-modal-button'
              : 'usf-fill-green-dsktp-tblt-modal-button'
            : !serviceRequestService?.modalRelatedParams?.product
            ? 'usf-fill-disabled-mobile-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        (click)="dismissModal(false)"
      >
        {{ 'i18n.requestCredit.select' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
